const state = {
    loading: false,
    ecom: [],
};

export default state;